/**
 * Created by Alex Aguilar on 9/7/2016.
 */
(function(){
    'use strict';

    var navbarHeader = {
        templateUrl: 'app/components/header/navbarHeader.html',
        controller: navbarHeaderController,
        controllerAs: 'vm'
    }

    angular
        .module('completeAir')
        .component('navbarHeader', navbarHeader);

    navbarHeaderController.$inject = ['$rootScope', 'menuService', '$state', 'Auth', 'Principal','userService'];

    function navbarHeaderController($rootScope, menuService, $state, Auth, Principal, userService){
        var vm = this;
        vm.menus = [];
        vm.menuName = "";
        vm.menu = null;
        vm.isAuthenticated = Principal.isAuthenticated();
        $rootScope.loginNames = '';
        $rootScope.loginInitials = '';

        if(vm.isAuthenticated){
            userService.getSession(false)
                .then(function(response){

                    menuService.getMenusUser()
                        .then(function(responseMenu){
                            vm.menus = responseMenu.data;
                            vm.menu = vm.menus[0];
                            vm.showSidebarMenu(vm.menu.menus, vm.menu.name);
                        });

                    var name = response.data.name?
                        (response.data.name.indexOf(' ') == -1?
                            response.data.name:
                            response.data.name.substring(0,(response.data.name.indexOf(' ')))):
                        '';
                    var lastName = response.data.lastName?
                        (response.data.lastName.indexOf(' ') == -1?
                            response.data.lastName:
                            response.data.lastName.substring(0,(response.data.lastName.indexOf(' ')))):
                        '';
                    var sigla = (name?name.charAt(0):'')+ (lastName?lastName.charAt(0):'');
                    $rootScope.loginNames = name + ' '+lastName;
                    $rootScope.loginInitials = sigla.toUpperCase();
                });
        }

        vm.showSidebarMenu = function(menus, name){
            $rootScope.$broadcast('navbar', menus);
            vm.menuName = name;
        }

    }
})();
